module.exports = __webpack_public_path__ + "img/icon_delete_blue.8a7c00dc.svg";